import { useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';

const useDeviceInfo = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    device: 'desktop',
    isWebView: false,
  });

  useEffect(() => {
    const parser = new UAParser();
    const userAgent = navigator.userAgent.toLowerCase();
    parser.setUA(userAgent);

    const os = parser.getOS().name?.toLowerCase() || '';
    let deviceType = 'desktop';

    // Enhanced iPad detection
    if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && os === 'mac os') {
      deviceType = 'ipad';
    } else if (os.includes('android')) {
      deviceType = 'android';
    } else if (os.includes('ios') || os.includes('iphone') || os.includes('ipad')) {
      deviceType = 'ios';
    }

    // Detect WebView
    const isAndroidWebView = /version\/[\d.]+.*chrome\/[0-9]+/.test(userAgent) && !/chrome\/[0-9]+ safari\/[0-9]+/.test(userAgent);
    const isIOSWebView = /(iphone|ipad|ipod).*applewebkit(?!.*safari)/.test(userAgent);
    const isWebView = isAndroidWebView || isIOSWebView;

    setDeviceInfo({ device: deviceType, isWebView });
  }, []);

  return deviceInfo;
};

export default useDeviceInfo;
